import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { AlcoholicDrinkPropertiesSubformComponent } from './components/alcoholic-drink/alcoholic-drink-properties-subform/alcoholic-drink-properties-subform.component';
import { BeerPropertiesSubformComponent } from './components/alcoholic-drink/beer/beer-properties-subform/beer-properties-subform.component';
import { BeerPropertiesComponent } from './components/alcoholic-drink/beer/beer-properties/beer-properties.component';
import { ChampagnePropertiesSubformComponent } from './components/alcoholic-drink/champagne/champagne-properties-subform/champagne-properties-subform.component';
import { GrapeWinePropertiesSubformComponent } from './components/alcoholic-drink/grape-wine/grape-wine-properties-subform/grape-wine-properties-subform.component';
import { LowAlcoholContentPropertiesComponent } from './components/alcoholic-drink/low-alcohol-content/low-alcohol-content-properties/low-alcohol-content-properties.component';
import { OtherAlcoholPropertiesSubformComponent } from './components/alcoholic-drink/other-alcohol/other-alcohol-properties-subform/other-alcohol-properties-subform.component';
import { BitterPropertiesSubformComponent } from './components/alcoholic-drink/spirit/bitter/bitter-properties-subform/bitter-properties-subform.component';
import { CognacPropertiesSubformComponent } from './components/alcoholic-drink/spirit/cognac/cognac-properties-subform/cognac-properties-subform.component';
import { FruitSpiritPropertiesSubformComponent } from './components/alcoholic-drink/spirit/fruit-spirit/fruit-spirit-properties-subform/fruit-spirit-properties-subform.component';
import { GinPropertiesSubformComponent } from './components/alcoholic-drink/spirit/gin/gin-properties-subform/gin-properties-subform.component';
import { LiqueurPropertiesSubformComponent } from './components/alcoholic-drink/spirit/liqueur/liqueur-properties-subform/liqueur-properties-subform.component';
import { OtherSpiritPropertiesSubformComponent } from './components/alcoholic-drink/spirit/other-spirit/other-spirit-properties-subform/other-spirit-properties-subform.component';
import { RumPropertiesSubformComponent } from './components/alcoholic-drink/spirit/rum/rum-properties-subform/rum-properties-subform.component';
import { SpiritPropertiesSubformComponent } from './components/alcoholic-drink/spirit/spirit-properties-subform/spirit-properties-subform.component';
import { TequilaPropertiesSubformComponent } from './components/alcoholic-drink/spirit/tequila/tequila-properties-subform/tequila-properties-subform.component';
import { VodkaPropertiesSubformComponent } from './components/alcoholic-drink/spirit/vodka/vodka-properties-subform/vodka-properties-subform.component';
import { WhiskyPropertiesSubformComponent } from './components/alcoholic-drink/spirit/whisky/whisky-properties-subform/whisky-properties-subform.component';
import { PackagingUnitComponent } from './components/forms/packaging-unit/packaging-unit.component';
import { ProductPackagingUnitsEffects } from './components/forms/packaging-unit/store/product-packaging-unit.effect';
import { ProductPackagingUnitFeature } from './components/forms/packaging-unit/store/product-packaging-unit.slice';
import { ProductCollectionLevelComponent } from './components/forms/product-collection-level/product-collection-level.component';
import { ProductVariantComponent } from './components/forms/product-variant/product-variant.component';
import { CocktailSyrupPropertiesSubformComponent } from './components/non-alcoholic-drink/cocktail-syrup/cocktail-syrup-properties-subform/cocktail-syrup-properties-subform';
import { CoffeePropertiesSubformComponent } from './components/non-alcoholic-drink/coffee/coffee-properties-subform/coffee-properties-subform.component';
import { EnergyDrinkPropertiesSubformComponent } from './components/non-alcoholic-drink/energy-drink/energy-drink-properties-subform/energy-drink-properties-subform.component';
import { JuicePropertiesSubformComponent } from './components/non-alcoholic-drink/juice/juice-properties-subform/juice-properties-subform.component';
import { MineralWaterPropertiesSubformComponent } from './components/non-alcoholic-drink/mineral-water/mineral-water-properties-subform/mineral-water-properties-subform.component';
import { NonAlcoholicDrinkPropertiesSubformComponent } from './components/non-alcoholic-drink/non-alcoholic-drink-properties-subform/non-alcoholic-drink-properties-subform.component';
import { SoftDrinkPropertiesSubformComponent } from './components/non-alcoholic-drink/soft-drink/soft-drink-properties-subform/soft-drink-properties-subform.component';
import { SyrupPropertiesSubformComponent } from './components/non-alcoholic-drink/syrup/syrup-properties-subform/syrup-properties-subform.component';
import { TeaPropertiesSubformComponent } from './components/non-alcoholic-drink/tea/tea-properties-subform/tea-properties-subform.component';
import { OptionalProductPropertiesSubformComponent } from './components/optional-product-properties/optional-product-properties-subform/optional-product-properties-subform.component';
import { SpecialPropertiesSubformComponent } from './components/optional-product-properties/special-properties-subform/special-properties-subform.component';
import { ProductAllergenicSubformComponent } from './components/product-allergenic-subform/product-allergenic-subform.component';
import { ProductBasicDataComponent } from './components/product-basic-data/product-basic-data.component';
import { ProductCollectionsComponent } from './components/product-collections/product-collections.component';
import { ProductCollectionsEffects } from './components/product-collections/store/product-collections.effect';
import { ProductCollectionsFeature } from './components/product-collections/store/product-collections.slice';
import { ProductCustomerSegmentSubformComponent } from './components/product-customer-segment-subform/product-customer-segment-subform.component';
import { ProductImagesComponent } from './components/product-images/product-images.component';
import { ProductEditComponent } from './containers/product-edit/product-edit.component';
import { ProductsContainerComponent } from './containers/products-container/products-container.component';
import { ProductPendingComponent } from './layouts/product-pending/product-pending.component';
import { ProductPublishedComponent } from './layouts/product-published/product-published.component';
import { ProductRejectedComponent } from './layouts/product-rejected/product-rejected.component';
import { ProductsRoutingModule } from './products-routing.module';
import { ProductsComponent } from './products.component';
import { ProductEffects } from './store/products.effects';
import { ProductsFeature } from './store/products.slice';
import { StatementEffects } from './store/statement.effects';
import { StatementFeature } from './store/statement.slice';

@NgModule({
  declarations: [
    ProductsComponent,
    ProductPendingComponent,
    ProductRejectedComponent,
    ProductsContainerComponent,
    ProductEditComponent,
    ProductBasicDataComponent,
    ProductCollectionsComponent,
    ProductPublishedComponent,
    BeerPropertiesComponent,
    LowAlcoholContentPropertiesComponent,
    BeerPropertiesSubformComponent,
    AlcoholicDrinkPropertiesSubformComponent,
    ProductCustomerSegmentSubformComponent,
    OptionalProductPropertiesSubformComponent,
    ProductAllergenicSubformComponent,
    SpiritPropertiesSubformComponent,
    CognacPropertiesSubformComponent,
    WhiskyPropertiesSubformComponent,
    RumPropertiesSubformComponent,
    GinPropertiesSubformComponent,
    VodkaPropertiesSubformComponent,
    LiqueurPropertiesSubformComponent,
    TequilaPropertiesSubformComponent,
    BitterPropertiesSubformComponent,
    FruitSpiritPropertiesSubformComponent,
    OtherSpiritPropertiesSubformComponent,
    GrapeWinePropertiesSubformComponent,
    OtherAlcoholPropertiesSubformComponent,
    ChampagnePropertiesSubformComponent,
    SyrupPropertiesSubformComponent,
    CocktailSyrupPropertiesSubformComponent,
    TeaPropertiesSubformComponent,
    SoftDrinkPropertiesSubformComponent,
    MineralWaterPropertiesSubformComponent,
    JuicePropertiesSubformComponent,
    EnergyDrinkPropertiesSubformComponent,
    CoffeePropertiesSubformComponent,
    NonAlcoholicDrinkPropertiesSubformComponent,
    SpecialPropertiesSubformComponent,
    PackagingUnitComponent,
    ProductCollectionLevelComponent,
    ProductImagesComponent,
    ProductVariantComponent,
  ],
  imports: [
    CommonModule,
    ProductsRoutingModule,
    StoreModule.forFeature(ProductsFeature),
    StoreModule.forFeature(StatementFeature),
    StoreModule.forFeature(ProductPackagingUnitFeature),
    StoreModule.forFeature(ProductCollectionsFeature),
    EffectsModule.forFeature([
      ProductEffects,
      StatementEffects,
      ProductPackagingUnitsEffects,
      ProductCollectionsEffects,
    ]),
    SharedModule,
  ],
})
export class ProductsModule {}
